import type { JSX } from 'react'

export const QualityBadge4kIcon = (): JSX.Element => (
  <use href='#qualityBadge4kIcon' height='100%' width='100%' />
)
